import classNames from 'classnames'
import { BsTrash3 } from 'react-icons/bs'
import { MdOutlineEdit } from 'react-icons/md'

import type { ReactElement, ReactNode } from 'react'

import './styles.scss'

interface Props {
  className?: string
  content: ReactNode
  onEditClick?: VoidFunction
  onRemoveClick?: VoidFunction
  titleComponent?: ReactNode
  type?: 'edit' | 'remove'
}

const IapCard = ({ className, content, onEditClick, onRemoveClick, titleComponent, type }: Props): ReactElement => {
  const inappCardComponentClasses = classNames('inapp-card-component', className)

  return (
    <div className={inappCardComponentClasses}>
      <div className="inapp-card-component__left">
        {titleComponent ? (
          <div className="inapp-card-component__left__header">
            <div className="inapp-card-component__left__header__title">{titleComponent}</div>
            {type === 'edit' ? (
              <div className="inapp-card-component__left__header__edit-icon" onClick={onEditClick}>
                <MdOutlineEdit size={18} />
              </div>
            ) : (
              <div />
            )}
          </div>
        ) : null}
        <div className="inapp-card-component__left__body">{content}</div>
      </div>
      {type === 'remove' ? (
        <div className="inapp-card-component__remove-icon" onClick={onRemoveClick}>
          <BsTrash3 color="red" size={16} />
        </div>
      ) : (
        <div />
      )}
    </div>
  )
}

export default IapCard
